import 'components/user_panel_menu';
import './index.scss';

(function () {
  'use strict';

  window.onApplicationLoaded(() => {
    const $menuToggleInput = $('.q-user-panel-menu-toggle-input');

    if (MediaQuery.is('sm') && MediaQuery.is('lt_md')) {
      $menuToggleInput.prop('checked', true);
    }
  });
}());
